import { Pipe, PipeTransform } from '@angular/core';
import { ResourceType } from '@panaya/ai-chat/shared';
import { IconName } from '@panaya/ui/p-icon';
import { injectAttachmentSources } from './attachment-source.provider';

const FALLBACK_ICON: IconName = 'paperclip';

/** The icon of the "+" menu item an attachment came from, for showing it on a sent message. */
@Pipe({ standalone: true, name: 'attachmentIcon' })
export class AttachmentIconPipe implements PipeTransform {
    private readonly sources = injectAttachmentSources();

    public transform(resourceType: ResourceType): IconName {
        return this.sources.find((source) => source.resourceType === resourceType)?.icon ?? FALLBACK_ICON;
    }
}
